import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import { Image, Text, Clamp } from 'components/atoms';

const ImageFile = ({ src, alt, isPortal }) => {
  const [isLoaded, setLoaded] = useState(false);
  return (
    <Wrapper>
      <ImageContainer isLoaded={isLoaded}>
        <Image
          src={src}
          alt={alt}
          width={64}
          onLoad={() => setLoaded(true)}
          isPortal={isPortal}
        />
      </ImageContainer>
      <Text modifiers={['light']}>
        <Clamp>{alt || 'Sem descrição'}</Clamp>
      </Text>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
`;

const ImageContainer = styled.div`
  width: 64px;
  height: 40px;
  background-color: ${props => (props.isLoaded ? props.theme.colors.bg : props.theme.colors.bgLighterS)};
  margin-right: ${props => props.theme.spacing.xs};
`;

ImageFile.defaultProps = {
  isPortal: false,
};

ImageFile.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  isPortal: PropTypes.bool,
};

export default ImageFile;
